export const ExcludeAirlines = [
  'SVO',
  'DME',
  'LED',
  'VVO',
  'KBP',
  'ODS',
  'LWO',
  'MSQ',
  'HAV',
  'VRA',
  'SCU',
  'IKA',
  'THR',
  'SYZ',
  'MHD',
  'FNJ',
  'DAM',
  'ALE',
  'KRT',
  'PZU',
  'SIP'
];
